module.exports = __webpack_public_path__ + "static/media/logout-active.fd647193.png";